import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import UpdateBanner from './UpdateBanner';

export default function NavTabs() {
  const { user, isAuthenticated, hasFullAccess, isAdmin, isOrgAccount } = useAuth();
  const canManageFacility = isAdmin || (isOrgAccount && Boolean(user?.linked_facility_id));

  const tabs = [
    { to: '/',        label: 'Treatment' },
    { to: '/housing', label: 'Housing' },
    { to: '/moud',    label: 'MOUD' },
    ...((hasFullAccess || isAdmin) ? [{ to: '/favorites', label: 'Favorites' }] : []),
    ...(canManageFacility        ? [{ to: '/my-facility', label: 'My Facility' }] : []),
    ...(isAuthenticated          ? [{ to: '/account',   label: 'Account'   }] : []),
    { label: 'Educational Resources', comingSoon: true },
    { to: '/faq', label: 'FAQ' },
    { to: '/why-subscribe', label: 'Why Subscribe' },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
      <UpdateBanner />
      <div className="max-w-7xl mx-auto px-4">
        <nav className="flex items-center overflow-x-auto scrollbar-hide gap-0">
          {tabs.map((tab) => {
            if (tab.comingSoon) {
              return (
                <span
                  key={tab.label}
                  className="flex items-center gap-1.5 px-4 py-3 text-sm font-medium whitespace-nowrap text-gray-400 dark:text-gray-500 cursor-default border-b-2 border-transparent select-none"
                >
                  {tab.label}
                  <span className="text-[10px] bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 px-1.5 py-0.5 rounded-full font-semibold leading-none">
                    Soon
                  </span>
                </span>
              );
            }
            return (
              <NavLink
                key={tab.to}
                to={tab.to}
                end={tab.to === '/'}
                className={({ isActive }) =>
                  `px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${
                    isActive
                      ? 'border-blue-600 text-blue-700 dark:text-blue-400 dark:border-blue-400'
                      : 'border-transparent text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:border-gray-300 dark:hover:border-gray-500'
                  }`
                }
              >
                {tab.label}
              </NavLink>
            );
          })}
        </nav>
      </div>
    </div>
  );
}
